export enum VideoPackageTypeEnum {
    DTV = 'DTV',
    ATV = 'ATV',
    GENRE = 'GENRE'
}

export enum VideoPackageTypeDisplayEnum {
    STREAM = 'STREAM',
    SATELLITE = 'SATELLITE'
}